export default "__VITE_ASSET__46ba3d50__"